// TODO: apagar esse arquivo quando o autosuggest estiver pronto
import { ICoordate } from "../coordinate/ICoordinate.model"

export type AutoSuggest = ISuggest[]

export interface ISuggest {
  id: string
  title: string
  address: IAddress
  position?: ICoordate
}

export interface IAddress {
  label: string
  houseNumber: string
  countryCode: string
  countryName: string
  stateCode: string
  state: string
  city: string
  district: string
  street: string
  postalCode: string
}
